import { useCallback, useEffect, useState } from 'react';
import { fetchPublicPagesSettings } from '../services/publicPagesService';

export default function usePublicPagesSettings({ publicAccess = false } = {}) {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const reload = useCallback(async (force = false) => {
    setLoading(true);
    setError(null);
    try {
      const data = await fetchPublicPagesSettings({ publicAccess, force });
      setSettings(data);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [publicAccess]);

  useEffect(() => {
    reload(false);
  }, [reload]);

  return { settings, loading, error, reload };
}
